// assume this needs to be loaded from BE. This is a mock data for now.
export const CollectionFilterOptions = [
  {
    label: 'Jira Products',
    options: [
      { label: 'Jira', value: 'jira' },
      { label: 'Advanced planning', value: 'advanced_planning' },
      { label: 'Jira Mobile Apps', value: 'jira_mobile_apps' },
      { label: 'Jira Service Management', value: 'jira_service_management' },
      { label: 'Jira Product Discovery', value: 'jira_product_discovery' },
      { label: 'Jira Align', value: 'jira_align' },
    ],
  },
  {
    label: 'Collaboration Tools',
    options: [
      { label: 'Confluence', value: 'confluence' },
      { label: 'Trello', value: 'trello' },
    ],
  },
  {
    label: 'Support and Operations',
    options: [
      { label: 'Assist', value: 'assist' },
      { label: 'Opsgenie', value: 'opsgenie' },
      { label: 'Statuspage', value: 'statuspage' },
    ],
  },
  {
    label: 'Development Tools',
    options: [
      { label: 'Bitbucket', value: 'bitbucket' },
      { label: 'Pipelines', value: 'pipelines' },
      { label: 'Bamboo', value: 'bamboo' },
      { label: 'Fisheye/Crucible', value: 'fisheye_crucible' },
      { label: 'Sourcetree', value: 'sourcetree' },
    ],
  },
  {
    label: 'Platform and Security',
    options: [
      { label: 'Atlassian Home', value: 'atlassian_home' },
      { label: 'Atlassian Guard', value: 'atlassian_guard' },
      { label: 'Atlassian Account', value: 'atlassian_account' },
      { label: 'Atlassian Automation', value: 'atlassian_automation' },
      { label: 'Atlassian Platform', value: 'atlassian_platform' },
      { label: 'Atlassian Analytics', value: 'atlassian_analytics' },
    ],
  },
  {
    label: 'Community and Events',
    options: [
      { label: 'Community Announcements', value: 'community_announcements' },
      { label: 'Community Events', value: 'community_events' },
    ],
  },
  {
    label: 'Groups',
    options: [
      { label: 'Focus', value: 'focus' },
      { label: 'Talent', value: 'talent' },
      { label: 'Featured Groups', value: 'featured_groups' },
      { label: 'Community Groups', value: 'community_groups' },
      { label: 'Product Groups', value: 'product_groups' },
      { label: 'Product Feedback Groups', value: 'product_feedback_groups' },
      { label: 'Industry Groups', value: 'industry_groups' },
      { label: 'Language Groups', value: 'language_groups' },
    ],
  },
];

export const TypeFilterOptions = [
  { label: 'Questions', value: 'questions' },
  { label: 'Discussions', value: 'discussions' },
  { label: 'Articles', value: 'articles' },
];

export const SortFilterOptions = [
  { label: 'Most recent', value: 'recent' },
  { label: 'Oldest', value: 'oldest' },
  { label: 'Most views', value: 'views' },
  { label: 'Most likes', value: 'likes' },
  { label: 'Trending', value: 'trending' },
];

export const StatusFilterOptions = [
  { label: 'All', value: 'all' },
  { label: 'Recommended', value: 'recommended' },
  { label: 'Solved', value: 'solved' },
  { label: 'Unsolved', value: 'unsolved' },
  { label: 'Had replies', value: 'had_replies' },
  { label: 'Has no replies', value: 'has_no_replies' },
];
